import type { VideoId } from '@/types/common'

/** router 설정, 페이지 이동시 사용하는 객체 */
const pagePath = {
  login: '/auth/login',
  loginGoogleRedirect: '/auth/login/google/redirect',
  signup: '/auth/signup',
  signupGoogleRedirect: '/auth/signup/google/redirect',
  myPage: '/my-page',
  channelDetail: (email: string) => `/manage/${email}/channel`,
  verifyChannel: '/channels/verify',
  selectVerifyMethod: '/channels/verify/select-method',
  verifyChannelEmail: '/channels/verify/email',
  channelVideos: (email: string) => `/manage/${email}/videos`,
  videoDetail: (videoId: VideoId) => `/manage/videos/${videoId}`,
} satisfies Record<string, string | ((...args: any[]) => string)>

export default pagePath
